import React from 'react'
import Spinner from './Spinner'
import { Text } from 'library/atoms/Typography'
import {
  StyleGuideMain,
  StyleGuideIdProps
} from 'shared/library/pages/StyleGuide'

const PROPS = {
  Description: () => <Text>Spinner for indiciating something is loading.</Text>,
  examples: [
    {
      title: 'Default',
      code: `<Spinner/>`,
      scope: { Spinner }
    },
    {
      title: 'Centered',
      code: `<Spinner centered={true}/>`,
      scope: { Spinner }
    }
  ]
}

const SpinnerStyleGuide = (props: StyleGuideIdProps) => (
  <StyleGuideMain {...props} {...PROPS} />
)

export default SpinnerStyleGuide
